import './OfferAndDealDatePicker.css';
import React, { useContext, useMemo, createRef, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Flatpickr from 'react-flatpickr';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { Norwegian } from 'flatpickr/dist/l10n/no.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';
import { addQueryString, deleteQueryString } from '../../Listing/index';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconChevronDown } from '../../../resources/icons/IconChevronDown.svg';
import { get, canUseDOM } from '../../../utils';
import { DATE_RANGE_FACET_NAME } from '../constants';
const commonStyles = "c1hy6aiu";
const ltrStyles = "lgvbbp7";
const rtlStyles = "r8qzx65";
const getFormatedDate = (date, lang) => {
  return new Date(date).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, {
    // year: 'numeric',
    day: 'numeric',
    month: 'short'
  });
};
const OfferAndDealDatePicker = _ref => {
  let {
    filter,
    closeMobileOpener,
    setValue,
    submitedValue,
    valueReadableString,
    value,
    clearText,
    ctaText,
    setListingFilter,
    externalVisible,
    setExternalVisible
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const history = useHistory();
  const currentLang = get(sitecoreContext, 'language').toLowerCase();
  const labelText = get(filter, 'title.jss.value');
  const dateFromFieldName = get(filter, 'fieldNameItem.item.dateFromFieldName.value');
  const dateToFieldName = get(filter, 'fieldNameItem.item.dateToFieldName.value');
  const [valueForSubmited, setValueForSubmited] = React.useState();
  const fieldOpenedRef = useRef(null);
  const filterName = get(filter, 'name') || '';
  const fieldId = filterName ? filterName.toLowerCase().replace(/ /g, '-') : '';
  const [fieldVisible, setFieldVisible] = useState(false);
  const [dateToDisable, setDateToDisable] = React.useState('');
  const fp = /*#__PURE__*/createRef();
  const currentLocale = useMemo(() => {
    const langHash = {
      ar: Arabic,
      ru: Russian,
      cs: Czech,
      nl: Dutch,
      fi: Finnish,
      de: German,
      ja: Japanese,
      no: Norwegian,
      pt: Portuguese,
      sv: Swedish,
      zh: Mandarin,
      da: Danish,
      fr: French,
      it: Italian,
      ko: Korean,
      pl: Polish,
      ro: Romanian,
      es: Spanish,
      uk: Ukrainian,
      tr: Turkish
    };
    return langHash[currentLang];
  }, [currentLang]);
  React.useEffect(() => {
    if (!value) {
      clearFilter();
    }
  }, [value]);
  const commonSubmit = () => {
    closeMobileOpener();
    setListingFilter();
    setFieldVisible(false);
    submitedValue && submitedValue(valueForSubmited);
  };
  const clearFilter = () => {
    if (fp && fp.current && fp.current.flatpickr) {
      fp.current.flatpickr.clear();
    }
    setValue({
      value: '',
      valueReadableString: ''
    });
    setValueForSubmited({
      value: '',
      valueReadableString: ''
    });
    deleteQueryString(DATE_RANGE_FACET_NAME, history);
    setDateToDisable('');
    commonSubmit();
  };
  const submitFilter = () => {
    addQueryString(DATE_RANGE_FACET_NAME, value, history);
    commonSubmit();
  };
  const hideDD = e => {
    if (fieldOpenedRef.current) {
      const mobileDevice = window.matchMedia(`(max-width: 991px)`).matches;
      if (e.type === 'scroll') {
        if (mobileDevice) return;
      }
      if (e.type === 'click') {
        if (mobileDevice || e.target.closest(`#${fieldId}`)) return;
      }
      setFieldVisible(false);
    }
  };
  useEffect(() => {
    fieldOpenedRef.current = fieldVisible;
  }, [fieldVisible]);
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('scroll', hideDD);
      document.addEventListener("click", hideDD);
    }
    return () => {
      if (canUseDOM) {
        window.removeEventListener('scroll', hideDD);
        document.removeEventListener("click", hideDD);
      }
    };
  }, []);
  useEffect(() => {
    if (externalVisible && externalVisible === filterName) {
      setFieldVisible(true);
      setExternalVisible('');
    }
  }, [externalVisible, filterName, setExternalVisible]);
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    id: fieldId
  }, /*#__PURE__*/React.createElement("div", {
    className: `button d-none d-lg-flex ${fieldVisible ? 'button--active' : ''}`,
    onClick: () => {
      setFieldVisible(!fieldVisible);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "button__text"
  }, labelText), /*#__PURE__*/React.createElement(IconChevronDown, null)), /*#__PURE__*/React.createElement("div", {
    className: `dropdown ${fieldVisible ? 'd-flex d-lg-block' : 'd-none'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: () => {
      setFieldVisible(false);
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, labelText), /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: clearFilter
  }, clearText)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body__clear d-none d-lg-block"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn-link",
    onClick: clearFilter
  }, clearText)), /*#__PURE__*/React.createElement(Flatpickr, {
    ref: fp,
    "aria-label": labelText,
    options: {
      showMonths: 1,
      mode: "range",
      minDate: dateToDisable || 'today',
      inline: true,
      locale: currentLocale || 'en',
      nextArrow: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="#007CBA" fill-rule="nonzero" d="M8.394 5.5L13 10l-4.606 4.5a1.904 1.904 0 0 1 0-2.724L10.212 10 8.394 8.224a1.904 1.904 0 0 1 0-2.724z"/></svg>`,
      prevArrow: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="#007CBA" fill-rule="nonzero" d="M8.394 5.5L13 10l-4.606 4.5a1.904 1.904 0 0 1 0-2.724L10.212 10 8.394 8.224a1.904 1.904 0 0 1 0-2.724z"/></svg>`
    },
    onChange: date => {
      if (date && date.length !== 0) {
        /* setDateInit(date); */
        const date0Temp = new Date(date[0]);
        setDateToDisable(date0Temp);
        const userTimezoneOffset = date0Temp.getTimezoneOffset() * 60000;
        const date0 = new Date(date0Temp.getTime() - userTimezoneOffset).toString();
        if (date[1]) {
          const date1Temp = new Date(date[1]);
          const userTimezoneOffset1 = date1Temp.getTimezoneOffset() * 60000;
          const date1 = new Date(date1Temp.getTime() - userTimezoneOffset1).toString();
          const dateValue = `(${dateToFieldName} > ${Date.parse(date0) / 1000} AND ${dateFromFieldName} < ${Date.parse(date1) / 1000})`;
          const dateString = `${getFormatedDate(date[0], currentLang)} - ${getFormatedDate(date[1], currentLang)}`;
          const value = {
            value: dateValue,
            valueReadableString: dateString
          };
          setValue(value);
          setValueForSubmited(value);
        } else {
          const value = {
            value: `(${dateToFieldName} > ${Date.parse(date0) / 1000 - 86400} AND ${dateFromFieldName} < ${Date.parse(date0) / 1000 + 86400})`,
            valueReadableString: getFormatedDate(date[0], currentLang)
          };
          setValue(value);
          setValueForSubmited(value);
        }
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: submitFilter
  }, ctaText))));
};
export default OfferAndDealDatePicker;